<div class="layout-footer">
    Powered by
    <a
        href="https://triatechsol.com/"
        target="_blank"
        rel="noopener noreferrer"
        class="font-bold hover:underline"
        >TriA Tech Solution</a
    >
</div>
